<div *ngIf="this.coreService.showOpenBetsVisible==0"
     class="ui grid segment"
     id="cont_slipsegment"
     [ngStyle]="{'height': (this.tournamentsService.Page_Window_Height - 75) + 'px','font-size':'12px','margin-bottom':'0px','margin-top':'0px'}">

  <div class="ui fluid card"
       style="margin-bottom: 0;">
    <div style="background-color:#DCDCDC;height: 35px;font-size: 22px;padding: 8px;font-weight: bold;display:none">
      <div class="header"><span>{{"BETTING_SLIP" | t}}</span></div>
    </div>
    <div class="content"
         id="BettingSlip_Content">
      <!--id="sliptype"-->
      <div *ngIf="this.coreService.CustomerCardIsActive==1 "
           class="ui item menu"
           id="BettingSlipOpenBet">
        <a *ngIf="this.tournamentsService.openbetActive==0"
           class="ui disabled button"
           style="text-align:center;font-size:18px;width:100%">
          <span style="width:100%"
                tkey="OpenBets">{{"OpenBets" | t}}</span>
        </a>
        <a *ngIf="this.tournamentsService.openbetActive==1"
           class="ui button"
           (click)="showOpenBets();"
           style="text-align:center;background-color:orange;font-size:18px;width:100%">
          <span style="width:100%"
                tkey="OpenBets">{{"OpenBets" | t}}</span>
        </a>
      </div>
      <div class="ui three item menu"
           id="BettingSlip_Menu"
           style="font-size:22px">
        <a class="{{this.tournamentsService.BettingSlip_Menu_SlipType == 0 ? 'active': ''}} item"
           (click)="changeSlipType(0);"
           style="width:33%;text-align:center">
          <span style="width:100%">{{"Single" | t}}</span>
        </a>
        <a class="{{this.tournamentsService.BettingSlip_Menu_SlipType == 1 ? 'active': ''}} item"
           (click)="changeSlipType(1);"
           style="width:33%;text-align:center">
          <span style="width:100%">{{"Combi" | t}}</span>
        </a>
        <a class="{{this.tournamentsService.BettingSlip_Menu_SlipType == 2 ? 'active': ''}} item"
           (click)="changeSlipType(2);"
           style="width:33%;text-align:center">
          <span style="width:100%">{{"System" | t}}</span>
        </a>
      </div>
      <div
        [ngStyle]="{'height': (this.tournamentsService.Page_Window_Height -64-35-65-120-66-196-8-this.coreService.openbetsButtonHeight) + 'px'}">
        <div id="BettinsSlip_ItemsArea"
             [ngStyle]="{'height': this.tournamentsService.BettingSlip_Menu_SlipType == 2 ? (this.tournamentsService.Page_Window_Height -64-35-65-120-66-196-58-15-this.coreService.openbetsButtonHeight - (!brWidgetVisibility ? 0 : 155)) + 'px' :
            (this.tournamentsService.Page_Window_Height -64-35-65-120-66-196-8-15-this.coreService.openbetsButtonHeight - (!brWidgetVisibility ? 0 : 155)) + 'px'}">
          <div *ngIf="this.tournamentsService.rsbCounterVisible==1"
               id="RestoreBettingSlipCounter"
               style="width:390px;border-style:outset;position:relative;top:110px;left:65px">

            <div class="header"
                 style="background-color:orange;height:40px;text-align:center;cursor: context-menu;"
                 (click)="RestoreBettingSlipFunc();">
              <span style="font-weight:bold;font-size:18px;position:relative;top:9px"
                    tkey="Restore_Betting_Slip"></span>

            </div>
            <div class="content terminalButton"
                 style="height:40px">
              <button id="rbscounter1"
                      class="mini ui button"
                      style="background-color:orange;cursor:unset;"></button>
              <button id="rbscounter2"
                      class="mini ui button"
                      style="background-color:orange;cursor:unset;"></button>
              <button id="rbscounter3"
                      class="mini ui button"
                      style="background-color:orange;cursor:unset;"></button>
              <button id="rbscounter4"
                      class="mini ui button"
                      style="background-color:orange;cursor:unset;"></button>
              <button id="rbscounter5"
                      class="mini ui button"
                      style="background-color:orange;cursor:unset;"></button>
              <button id="rbscounter6"
                      class="mini ui button"
                      style="background-color:orange;cursor:unset;"></button>
              <button id="rbscounter7"
                      class="mini ui button"
                      style="background-color:orange;cursor:unset;"></button>
              <button id="rbscounter8"
                      class="mini ui button"
                      style="background-color:orange;cursor:unset;"></button>
              <button id="rbscounter9"
                      class="mini ui button"
                      style="background-color:orange;cursor:unset;"></button>
              <button id="rbscounter10"
                      class="mini ui button"
                      style="background-color:orange;cursor:unset;"></button>
            </div>


          </div>
          <div style="font-size: 22px;"
               id="BettingSlip_ItemsArea_EmptyList"
               *ngIf="this.tournamentsService.slipCurrents!=null && this.tournamentsService.slipCurrents.length < 1">
            <span>{{"Make_your_selection_on_the_left" | t}}</span>
            <img style="width: 265px;"
                 src="../../../Images/background-sketch.png"/>


          </div>

          <div class="slipItem"
               *ngFor="let slipEvent of this.tournamentsService.slipCurrents | groupByEventName ">


            <div class="slipItemHeader">
              <div class="teamNames">
                <span>
                  {{slipEvent?.HomeTeam}}<span class="redCard"
                                               *ngIf="slipEvent?.externalDatas?.cards?.HomeTeamRed > 0">{{slipEvent?.externalDatas?.cards?.HomeTeamRed}}</span>
                </span>
                <span>
                  {{slipEvent?.AwayTeam}}<span class="redCard"
                                               *ngIf="slipEvent?.externalDatas?.cards?.AwayTeamRed > 0">{{slipEvent?.externalDatas?.cards?.AwayTeamRed}}</span>
                </span>
              </div>
              <div style="flex-grow: 1"></div>

              <div class="dataPre"
                   *ngIf="slipEvent?.externalDatas.liveData?.TimeStatu < 2 || !slipEvent?.externalDatas.liveData ">
                {{ dataFormatter(slipEvent.EventDate) | date: 'EEEE dd/MM HH:mm'}}
              </div>

              <ng-container
                *ngIf="slipEvent?.externalDatas.liveData && slipEvent?.externalDatas.liveData?.TimeStatu > 1 ">
                <div class="liveIndicator">
                  <span>
                    {{
                    (slipEvent?.externalDatas.liveData?.TimeStatu == 3 || slipEvent?.SportName == 'Tennis') ?
                      slipEvent?.externalDatas.liveData?.TimeStatuColor : slipEvent?.externalDatas.liveData?.MatchTime == '' ?
                        slipEvent?.externalDatas.liveData?.TimeStatuColor : slipEvent?.externalDatas.liveData?.MatchTime
                    }}
                  </span>
                </div>

                <div class="liveScore">
                  <span>{{slipEvent?.externalDatas.liveData?.Score.split(':')[0]}}</span>
                  <span>{{slipEvent?.externalDatas.liveData?.Score.split(':')[1]}}</span>
                </div>
              </ng-container>

            </div>

            <div class="oddSection">
              <ng-container *ngFor="let slipCurrent of slipEvent?.eEvents">
                <div class="oddItem {{slipCurrent.Visibility=='hidden' ? 'redBG' : '' }}">
                  <div class="oddXIcon"
                       (click)="removeSlip(slipCurrent.OddId1)">
                    <span>X</span>
                  </div>


                  <div class="oddNameVal"><span>{{slipCurrent?.OddsType}} {{slipCurrent?.SpecialBetValue}}</span></div>
                  <div class="oddOutCome"><span>{{slipCurrent.OutCome}}</span></div>
                  <div *ngIf="this.tournamentsService.BettingSlip_Menu_SlipType == 2"
                       class="ui slider checkbox"
                       style="margin-top:-8px;margin-left: 5px;">

                    <button class="Banko_Btn {{banko_btn_style(slipCurrent)}}"
                            (click)="changeSelectedSlipCurrent(slipCurrent)">
                      <span>B</span>
                    </button>

                  </div>
                  <!-- "slipCurrent.Visibility" -->

                  <p style="flex-grow: 1"></p>

                  <div class="oddValue"
                       *ngIf="slipCurrent.Visibility !='hidden'">
                    <span>{{ +slipCurrent?.OddValue1 | number : '1.2-2'}}</span>
                  </div>


                </div>
              </ng-container>
            </div>
            <!--<div class="ui divider" style="margin: -0.5rem 1rem;"></div>-->
          </div>

        </div>

        <div *ngIf="this.tournamentsService.BettingSlip_Menu_SlipType == 2"
             style="padding:4px;background:orange">
          <button class="ui fluid button"
                  (click)="Open_BettinSlip_System_Modal()"
                  style="height:50px;background:orange">
            <span style="font-size:20px;text-transform:uppercase">
              {{this.tournamentsService?.SystemModalButtonValue}}
            </span>

          </button>
          <!--<div class="row" *ngFor="let systemSlip of this.tournamentsService.systemSlips; let i = index">
              <div class="ui three column grid">
                  <div class="column"><label><span tkey="CombiOf"></span> {{i+1}}</label></div>
                  <div class="column"><label><span tkey="Bets"></span> {{this.combination(i+1)}}</label></div>
                  <div class="column">
                      <div class="ui mini input" style="width:80px;">
                          <input type="checkbox" name="systemslipitem" value="0" (change)="changeAmount($event)">
                      </div>
                  </div>
              </div>
          </div>
          <div class="ui divider"></div>-->
        </div>
      </div>


      <div class="ui {{this.tournamentsService.slipCurrentDimmer}} {{inverted == '' ? 'inverted' : ''}} dimmer">
        <div class="ui loader"></div>
      </div>


    </div>

    <!--TOTAL RATE - TAX - BETS - AMOUNT PER BETS - MAX GAIN-->
    <div style="background-color:#DCDCDC;height: 155px;padding: 4px;" class="slip-informative">
      <div id="widgetContainer" #brWidget></div>

      <div class="ui grid"
           style="margin:0px;margin-top:10px;">
        <div class="four wide column"
             style="padding:1px">
          <!--<br />-->
          <button id="BettingSlip_Button_Reset"
                  (click)="clearall()"
                  style="background-color:white;font-size:16px">
            <span style="font-size: x-large;font-weight: bold;">{{"Reset" | t}}</span>
          </button>

        </div>
        <div class="twelve wide column"
             style="padding:1px">
          <div class="slipamounts">

            <!--<div class="ui form">
                <div class="fields">
                    <div class="six wide field">
                        <label id="cont_sliplabel"><span tkey="ToPay"></span></label>
                    </div>
                    <div class="ten wide field" style="text-align:right">

                        <span style="font-weight:bold" [style.text-align]="this.sitedirection">{{this.tournamentsService.slipAmount.ToPay}} </span>
                    </div>
                </div>
            </div>-->
            <div class="ui form">
              <div class="fields">
                <div class="eight wide field">
                  <label id="cont_sliplabel"
                         style="font-size:22px"><span>{{"TotalRate" | t}}</span></label>
                </div>
                <div class="eight wide field"
                     style="text-align:right">
                  <span style="font-size:22px;font-weight:bold">{{this.tournamentsService.slipAmount.TotalRate}} </span>
                </div>
              </div>
            </div>
            <!--*ngIf="this.tournamentsService.tax != 0"-->

            <div class="ui form">
              <div class="fields">
                <div class="eleven wide field">
                  <label id="cont_sliplabel"
                         style="font-size:22px;font-weight:400;"><span>{{"NumberOfBets" | t}}</span></label>
                </div>
                <div class="five wide field"
                     style="text-align:right">
                  <span
                    style="font-size:22px;font-weight:400">{{this.tournamentsService.slipAmount?.NumberOfBets}}</span>
                </div>
              </div>
            </div>
            <div class="ui form"
                 *ngIf="this.tournamentsService.slipAmount?.AmountPerBet != ''">
              <div class="fields">
                <div class="nine wide field">
                  <label id="cont_sliplabel"
                         style="font-size:22px;font-weight:400;"><span>{{"AmountPerBet" | t}}</span></label>
                </div>
                <div class="seven wide field"
                     style="text-align:right">
                <span
                  style="font-size:22px;font-weight:400">{{this.tournamentsService.slipAmount?.AmountPerBet}} {{this.coreService.customerUser.Symbol}} </span>
                </div>
              </div>
            </div>
            <div class="ui form">
              <div class="fields">
                <div class="six wide field">
                  <label id="cont_sliplabel"
                         style="font-size:22px;font-weight:400;"><span>{{"ToPay" | t}}</span></label>
                </div>
                <div class="ten wide field"
                     style="text-align:right">
                <span *ngIf="this.tournamentsService.CalculatorValue!=0"
                      style="font-size:22px;font-weight:400">{{this.tournamentsService.slipAmount?.ToPay}} {{this.coreService.customerUser?.Symbol}} </span>
                  <span *ngIf="this.tournamentsService.CalculatorValue==0"
                        style="font-size:22px;font-weight:400">0.00 </span>


                </div>
              </div>
            </div>

            <div class="ui form">
              <div class="fields">
                <div class="six wide field">
                  <label id="cont_sliplabel"
                         style="font-size:22px;font-weight:400;"><span>{{"Tax" | t}}</span></label>
                </div>
                <div class="ten wide field"
                     style="text-align:right">

                <span *ngIf="(this.tournamentsService.CalculatorValue-this.tournamentsService.amount*1).toFixed(2)>=0"
                      style="font-size:22px;font-weight:400"> {{(this.tournamentsService.CalculatorValue - this.tournamentsService.amount).toFixed(2)}} {{this.coreService.customerUser.Symbol}}  </span>
                  <span *ngIf="(this.tournamentsService.CalculatorValue-this.tournamentsService.amount).toFixed(2)<0"
                        style="font-size:22px;font-weight:400"> 0.00 {{this.coreService.customerUser.Symbol}}</span>
                </div>
              </div>
            </div>

            <div class="ui form">
              <div class="fields">
                <div class="six wide field">
                  <label id="cont_sliplabel"
                         style="font-size:20px"><span>{{"MaxGain" | t}}</span></label>
                </div>
                <div class="ten wide field"
                     style="text-align:right">
                  <span *ngIf="this.tournamentsService.CalculatorValue!=0"
                        style="font-size:22px;font-weight:bold">
                    {{this.tournamentsService.slipAmount?.MaxGain}} {{this.coreService.customerUser?.Symbol}}
                  </span>
                  <span *ngIf="this.tournamentsService.CalculatorValue==0"
                        style="font-size:22px;font-weight:bold">0.00 </span>


                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--TOTAL RATE - TAX - BETS - AMOUNT PER BETS - MAX GAIN-->
    <!--AMOUNT INPUT( DISPLAY NONE )-->
    <div class="content"
         style="display:none">
      <!--*ngIf="this.slipType != 2"-->
      <div class="fields amountfield"
           style="margin: 0px -5px 0px -5px;">
        <div class="six wide field">
          <label id="cont_sliplabel"
                 style="margin-top:6px;color:#fff"><span>{{"Amount" | t}}</span></label>
        </div>
        <div class="ten wide field"
             *ngIf="this.tournamentsService.tax != 0">
          <div class="ui mini input">
            <input type="text"
                   [(ngModel)]="this.tournamentsService.CalculatorValue"
                   (keyup)="changeTaxAmount(e)"
                   style="text-align:right;font-size:14px;"
                   (focusout)="focuslost()">
          </div>
        </div>
        <div class="ten wide field"
             *ngIf="this.tournamentsService.tax == 0">
          <div class="ui mini input">
            <input type="text"
                   [(ngModel)]="this.tournamentsService.CalculatorValue"
                   (keyup)="changeAmount($event)"
                   style="text-align:right;font-size:14px;"
                   (focusout)="focuslost()">
            <!--<div class="ui dropdown label" id="#dd_fastamount">
                <div class="text">5</div>
                <i class="dropdown icon"></i>
                <div class="menu">
                    <div class="item">10</div>
                    <div class="item">50</div>
                    <div class="item">100</div>
                </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!--AMOUNT INPUT( DISPLAY NONE )-->
    <!--ERROR MESSAGES-->
    <div style="background-color:#464040;height: 66px;padding: 8px;">
      <div style="background-color:white;width:100%;border-radius:4px;height:50px;overflow:auto"
           *ngIf="!this.error_oddrefresherror">
        <div *ngIf="this.tournamentsService.messageType == 'amountMessage'"
             class="ui negative message"
             style="padding:6px;font-size:17px;height:100%;">
          <span>{{"errorcode4" | t}}</span>
        </div>
        <div *ngIf="this.tournamentsService.messageType == 'errorMessage'"
             class="ui negative message"
             style="padding:6px;font-size:17px;height:100%;">
          <div>
            <span style="position:absolute;">{{this.tournamentsService?.message}}</span>
          </div>
        </div>
        <div *ngIf="this.tournamentsService.messageType == 'errorSystemMessage'"
        class="ui negative message"
        style="padding:6px;font-size:17px;height:100%;">
     <div>
       <span style="position:absolute;">{{this.tournamentsService?.message}}</span>
     </div>
   </div>
        <div *ngIf="this.tournamentsService.messageType == 'successMessage'"
             class="ui positive message"
             style="padding:6px;font-size:17px;height:100%;">
          <i class="checkmark icon"></i>
          <span>{{"successcode2" | t}}</span>
        </div>
        <div *ngIf="this.tournamentsService.messageType == 'loginMessage'"
             class="ui negative message"
             style="padding:6px;font-size:17px;height:100%;">
          <span style="position:absolute;">{{"errorcode5" | t}}</span>
        </div>
      </div>
      <div style="background-color:#f26202;width:100%;border-radius:4px;height:50px;overflow:auto;padding:3px;"
           *ngIf="this.error_oddrefresherror">
        <span style="color:white;font-size:17px;padding:10px;position:absolute;">{{"errorcodeoddclose" | t}}</span>
      </div>
      <!--<button class="ui fluid button" style="background-color:white"></button>-->
    </div>
    <!--ERROR MESSAGES-->

    <!--BALANCE / SUBMIT BET BUTTONS-->
    <div style="padding:8px;height: 196px;">
      <!--<button class="ui fluid button terminalButton" style="margin-bottom:8px;" (click)="Balance_Button_Open_Modal()">
          <span style="float:left;color:black">{{"Balance" | t}}</span>
          <span style="float:right;color:black">0.00</span>
      </button>-->
      <div *ngIf="this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet != true"
           class="ui icon fluid buttons"
           style="border:1px solid #bfb8b8;border-radius: 6px;height:97px">
        <button style="background: linear-gradient(to top, #C7C7C7, #FBFBFB);color:black"
                class="ui button"
                (click)="BettingSlip_StakeDecrease()"><i class="minus big icon"></i></button>
        <button style="background: linear-gradient(to bottom, #C7C7C7, #FBFBFB);color:black"
                (click)="Open_BettinSlip_Calculator_Modal()"
                class="ui button">
          <div>
            <span style="font-size:30px">{{"Stake" | t}}</span>
          </div>
          <div style="padding-top:18px">
            <span style="font-size:60px;">{{this.tournamentsService?.CalculatorValue| number : '1.2-2'}}</span>
          </div>
        </button>
        <button style="background: linear-gradient(to top, #C7C7C7, #FBFBFB);color:black"
                class="ui button"
                (click)="BettingSlip_StakeIncrease()"><i class="plus big icon"></i></button>
      </div>

      <button *ngIf="this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet != true &&
      this.coreService.customerUser.IsAnonymousBet == 0 && this.coreService.customerUser.IsTerminal == 1"
              style="height:75px;margin-top:8px;background: rgb(247, 187, 34)"
              class="fluid ui orange button submitbet"
              (click)="BettingSlip_Click_Confirm_Temp()">
        <span style="color:black;font-size:24px;line-height: 1.1">
          <ng-container *ngIf="this._uiHelper.terminalConfig.IsBetOn == true">
            <ng-container *ngIf="this._uiHelper.terminalConfig.TemporaryBet == false; else elseTemplate">
              {{"vorabticket" | t}}
            </ng-container>
            <ng-template #elseTemplate>
              {{getSubmitButtonText()}}
            </ng-template>

          </ng-container>
          <ng-container *ngIf="this._uiHelper.terminalConfig.IsBetOn == false">
            {{"betoff" | t}}
          </ng-container>
        </span>
      </button>


      <button *ngIf="
        this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet != true &&
        this.coreService.customerUser.IsAnonymousBet == 0 &&
        this.coreService.customerUser.IsTerminal == 0"
              style="height:75px;margin-top:8px;background: rgb(247, 187, 34)"
              class="fluid ui orange button submitbet"
              (click)="BettingSlip_Click_SubmitBet()">
        <span style="color:black;font-size:24px;line-height: 1.1">
          <ng-container *ngIf="this._uiHelper.terminalConfig.IsBetOn == true">
         {{getSubmitButtonText()}}
          </ng-container>
        </span>
      </button>


      <!-- this.coreService.customerUser.IsTerminal == 0 ise Müşteri Kartı takılı-->
      <button
        *ngIf="this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet != true && this.coreService.customerUser.IsAnonymousBet != 0"
        style="height:75px;margin-top:8px;background: rgb(247, 187, 34)"
        class="fluid ui orange button submitbet"
        (click)="BettingSlip_Click_SubmitBet()">
        <span style="color:black;font-size:24px;line-height: 1.1">
        <ng-container *ngIf="this._uiHelper.terminalConfig.IsBetOn != false &&
        this.coreService.customerUser.IsAnonymousBet != 0 && this.coreService.customerUser.IsTerminal == 0">
 {{getSubmitButtonText()}}
        </ng-container>

          <ng-container *ngIf="this._uiHelper.terminalConfig.IsBetOn != false &&
        this.coreService.customerUser.IsAnonymousBet != 0 && this.coreService.customerUser.IsTerminal == 1">
          {{getSubmitButtonText()}}
        </ng-container>

          <ng-container *ngIf="this._uiHelper.terminalConfig.IsBetOn == false &&
        this.coreService.customerUser.IsAnonymousBet != 0 && this.coreService.customerUser.IsTerminal == 0">
         {{getSubmitButtonText()}}
        </ng-container>

          <ng-container *ngIf="this._uiHelper.terminalConfig.IsBetOn == false &&
        this.coreService.customerUser.IsAnonymousBet != 0 && this.coreService.customerUser.IsTerminal == 1">
          {{"betoff" | t}}
        </ng-container>

        </span>
      </button>

      <button *ngIf="this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet == true"
              style="height:75px;margin-top:8px;"
              class="fluid ui red button"
              (click)="BettingSlip_Click_Modify()"><span
        style="color:white;font-size:22px">{{"Modify" | t}}</span></button>

      <!--      <button *ngIf="this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet == true"-->
      <!--              style="height:75px;margin-top:8px;" class="fluid ui green button" (click)="BettingSlip_Click_Confirm()">-->
      <!--        <span style="color:white;font-size:22px">{{"Confirm" | t}}</span></button>-->


      <ng-container *ngIf="this.coreService.CustomerCardIsActive != 1 && this.coreService.customerUser.IsAnonymousBet
       == 0">
        <button *ngIf="this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet == true"
                style="height:75px;margin-top:8px;"
                class="fluid ui green button"
                (click)="BettingSlip_Click_Confirm_Temp()">
          <span style="color:white;font-size:22px">{{"Confirm" | t}}</span></button>
      </ng-container>

      <ng-container *ngIf="this.coreService.CustomerCardIsActive == 1 || this.coreService.customerUser.IsAnonymousBet
       == 1 ">
        <button *ngIf="this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet == true"
                style="height:75px;margin-top:8px;"
                class="fluid ui green button"
                (click)="BettingSlip_Click_Confirm()">
          <span style="color:white;font-size:22px">{{"Confirm" | t}}</span></button>
      </ng-container>

    </div>
    <!--BALANCE / SUBMIT BET BUTTONS-->

  </div>


  <div class="ui dimmer"
       id="BettingSlip_CountDown_Dimmer">
    <div class="content"
         style="top:20%;position: absolute;">

      <div>
        <span>{{"Please_wait" | t}}</span>
      </div>
      <div>
        <h2 class="ui inverted icon header">{{this.BettingSlip_Countdown}}</h2>
      </div>
      <div>
        <span>{{"second(s)" | t}}</span>
      </div>


    </div>
  </div>


</div>
<div *ngIf="this.coreService.showOpenBetsVisible==1"
     class="ui grid segment"
     id="cont_slipsegment"
     [ngStyle]="{'height': (this.tournamentsService.Page_Window_Height - 75) + 'px','font-size':'12px','margin-bottom':'0px','margin-top':'0px'}">

  <div class="ui fluid card"
       style="margin-bottom: 0;">
    <div *ngIf="this.coreService.CustomerCardIsActive==1"
         class="ui item menu"
         id="BettingSlipOpenBet">
      <a *ngIf="this.tournamentsService.openbetActive==0"
         class="ui disabled button"
         style="text-align:center;font-size:18px;width:100%">
        <span style="width:100%">Coupon Detail</span>
      </a>
      <a *ngIf="this.tournamentsService.openbetActive==1"
         class="ui button"
         (click)="showOpenBets();"
         style="text-align:center;background-color:orange;font-size:18px;width:100%">
        <span style="width:100%">Coupon Detail</span>
      </a>
    </div>
    <div class="content"
         style="overflow:scroll;height:300px">
      <table>
        <tr *ngFor="let openslip of this.tournamentsService.openSlipList;let i=index">
          <td style="width:500px;padding-bottom:5px">

            <a class="ui button terminalButton cashoutSlipContainer"
               style="width:100%;padding:0px;
            padding-top:10px;font-size:18px">

              <div class="cashoutTicketRow bold">
                    <span>
                      <span style="margin-left:10px">{{openslip.Amount?.toFixed(2)}}</span>
                      <span
                        style="margin-left:5px">{{this.coreService.customerUser?.Symbol}}</span>
                      <span
                        style="margin-left:5px">{{openslip.Bets}}</span>
                      <span
                        style="margin-left:5px">{{openslip.SlipType}}</span>
                    </span>
              </div>


              <ng-container *ngFor="let events of openslip?.CashoutEvents">
                <div class="cashoutTicketRow">
                  {{events.EventName}}
                  <div *ngIf="events.Live == 'Live'"
                       class="live-dot"></div>
                </div>
              </ng-container>

              <div class="cashoutTicketRow bold">Max Gain: {{openslip?.Gain}}</div>

              <div class="cashoutTicketRow end mb-10">
                <div class="ui big button terminalButton"
                     (click)="getOpenBetDetail(openslip.SlipId)">Detail
                </div>
              </div>

              <div class="cashoutTicketRow">
                <div class="ui positive {{openslip?.CashOutActive}} button"
                     style="width:100%;color:white;font-size:22px"
                     (click)="getOpenBetDetail(openslip.SlipId)">
                  <span> {{"CASHOUT" | t}}: </span> <span>{{getCashoutValue(openslip)}}</span>
                </div>
              </div>

              <!--              <span [innerHtml]="openslip.Events" style="font-weight:100;"></span> <br/><br/>-->
              <!--              <span style="margin-left:85px">Max Gain: {{openslip?.Gain}}</span>-->
              <!--              <span class="ui big button terminalButton" style="float:right;position:relative;bottom:10px"-->
              <!--                    (click)="getOpenBetDetail(openslip.SlipId)">Detail</span>-->
              <!--              <span class="ui positive {{openslip?.CashOutActive}} button" style="width:100%;color:white;font-size:22px"-->
              <!--                    (click)="getOpenBetDetail(openslip.SlipId)">-->
              <!--                <span> {{"CASHOUT" | t}}: </span>       <span>{{openslip.CashoutValue?.toFixed(2)}}</span>-->

              <!--              </span>-->
            </a>

          </td>

        </tr>
      </table>


    </div>
  </div>

</div>

<div id="openBetsCashoutModal"
     class="ui modal">

  <div class="content">
    <span style="font-weight:bold;font-size:18px">{{"CASHOUT_WINNINGS_OF" | t}} {{this.openBetsCashoutValue}} €? </span>
    <button class="circular ui icon button"
            style="float:right;position:relative;bottom:10px;background-color:white;border: 1px solid;"
            (click)="ObCashoutModalExit()">
      <i class="remove link icon"></i>
    </button>
  </div>
  <div class="content"
       style="text-align:center">
    <button class="ui big button terminalButton"
            (click)="ObCashoutValueOk()"
            style="width:150px;">
      <span>{{"OK" | t}}</span></button> &nbsp;&nbsp;
    <button class="ui big  button terminalButton"
            (click)="ObCashoutModalExit()"
            style="width:150px;">
      <span>{{"CANCEL" | t}}</span></button>
  </div>
</div>
<div id="cashoutdetail_creditvoucheropenbets"
     class="ui modal"
     style="width: 710px;height:310px;position:absolute;right:115%;bottom:35%;">
  <button class="circular ui icon button"
          (click)="ExitCreditVoucherModalOb()"
          style="float:right;background-color: white;border: 1px solid;margin-top:1px;">
    <i class="remove link icon"></i>
  </button>
  <br/><br/>

  <!--<div><button class="ui circular button" (click)="ExitCreditVoucherModal()" style="float:right;">X</button></div><br /><br />-->
  <div class="content"
       style="text-align:center">
    <img src="../../../Images/creditvoucher.png"/>
  </div>
  <br/>
  <div style="text-align:center;font-size:18px;font-weight:bold;font-family:serif">
    <span>{{"Bet_successfully_redeemed._Your_balance_has_been_updated" | t}} </span></div>
  <br/>

  <div style="text-align:center">
    <button class="ui button"
            style="background-color:orange;width:250px"
            (click)="SubmitNewBetOb()">
      <span>{{"Submit_New_Bet" | t}}</span></button>
  </div>
  <br/>
  <div style="text-align:center;font-size:18px;font-weight:bold;font-family:serif">
    <span>{{"You_can_withdraw_your_credit_balance_by_pressing_on_'Credit_Voucher'_in_the_upper_right_corner_and_retrieve_your_credit_voucher._that_can_be_redeemed_at_our_cash_registers_in_the_shop" | t}}</span>
  </div>
  <br/><br/>

</div>
<style>
  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #000000;
  }
</style>


<comp_bettingslip_system_modal (systemSlip_ChangeAmount)="changeAmount($event)"></comp_bettingslip_system_modal>

<comp_bettingslip_calculator_modal
  (calculator_Modal_Ok)="changeAmount_From_Calculator($event)"></comp_bettingslip_calculator_modal>

<comp_bettingslip_balance_modal></comp_bettingslip_balance_modal>


<comp_print_slip></comp_print_slip>

<!--<comp_cashout></comp_cashout>-->
<!--<comp_sidebanner [locationId]="2"></comp_sidebanner>-->


<iframe hidden
        style="width:274px"
        id="Slip_PrintArea_Iframe"
        name="Slip_PrintArea_Iframe"></iframe>
